export const notes = state => state.notes
export const notesByDate = state => {
  const result = state.notes.reduce((acum, note) => {
    const date = note.createdAt.slice(0, 10)
    let dailyNotes = acum.find(dailyNote => dailyNote.date === date)
    if (!dailyNotes) {
      dailyNotes = { date: date, notes: [] }
      acum.push(dailyNotes)
    }
    dailyNotes.notes.push(note)
    return acum
  }, [])

  result.sort((note1, note2) => note2.date.localeCompare(note1.date))
  result.map(dailyNotes => dailyNotes.notes.sort((note1, note2) => note2.createdAt.localeCompare(note1.createdAt)))
  return result
}